<template>
  <div style="overflow:hidden; position:relative">
    <v-row no-gutters class="mb-12">
      <v-col cols="12" sm="8" md="7" lg="6" class="mx-auto pa-2">
        <p class="primary--text font-weight-bold display-1 pt-8 pb-6">
          Mi cuenta
        </p>
        <v-subheader class="title primary--text font-weight-bold"
          >Indicadores Generales</v-subheader
        >
        <v-row class="ml-1">
          <v-col cols="6">
            <div class="d-flex">
              <SvgIcon
                icon="cp-outlined-diver-2"
                :height="imageHeight"
                fill="#004480"
              ></SvgIcon>
              <div class="ml-4 flex d-flex flex-column justify-center">
                <p class="primary--text font-weight-bold display-1 mb-0">
                  {{ userDives }}
                </p>
                <p class="primary--text font-weight-medium body-1 mb-0">
                  buceos
                </p>
                <p class="primary--text font-weight-medium body-1 mb-0">
                  registrados
                </p>
              </div>
            </div>
          </v-col>
          <v-col cols="6">
            <div class="d-flex">
              <SvgIcon
                icon="cp-outlined-fish-1"
                :height="imageHeight"
                fill="#004480"
              ></SvgIcon>
              <div class="ml-4 flex d-flex flex-column justify-center">
                <p class="primary--text font-weight-bold display-1 mb-0">
                  {{ organismSee }}
                </p>
                <p class="primary--text font-weight-medium body-1 mb-0">
                  especies
                </p>
                <p class="primary--text font-weight-medium body-1 mb-0">
                  registradas
                </p>
              </div>
            </div>
          </v-col>
        </v-row>
        <v-divider class="primary mb-4 mt-4"></v-divider>
        <p class="title primary--text text-center font-weight-bold mb-2">
          Mantén actualizada la información de tu perfil
        </p>
        <div class="pt-0">
          <v-expansion-panels focusable>
            <v-expansion-panel class="mt-4 rounded-custom">
              <v-expansion-panel-header class="primary pt-0 pb-0">
                <v-list-item class="pl-0">
                  <v-list-item-avatar>
                    <SvgIcon
                      icon="cp-user"
                      fill="#c0e2e6"
                      height="35px"
                    ></SvgIcon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title
                      class="font-weight-medium title white--text"
                      >Datos generales</v-list-item-title
                    >
                    <v-list-item-subtitle class="white--text"
                      >Nombre, email, teléfono</v-list-item-subtitle
                    >
                  </v-list-item-content>
                </v-list-item>
              </v-expansion-panel-header>
              <v-expansion-panel-content
                class="pa-md-4 body-2 card-custom-background"
              >
                <div class="mb-10 mt-6">
                  <PractitionerProfilePictureUpload
                    :practitioner="formData"
                  ></PractitionerProfilePictureUpload>
                </div>
                <v-row>
                  <v-col cols="12" md="10">
                    <v-text-field
                      v-model="formData.name"
                      label="Nombre"
                      rounded
                      outlined
                      required
                    ></v-text-field>
                    <v-text-field
                      v-model="formData.email"
                      label="E-mail"
                      placeholder="name.user@costapez.org"
                      rounded
                      outlined
                      required
                    ></v-text-field>
                    <v-text-field
                      v-model="formData.phone"
                      label="Teléfono"
                      placeholder="(+56) 9 1234 5678"
                      outlined
                      rounded
                      required
                    ></v-text-field>
                    <v-menu
                      v-model="fromDateMenu"
                      ref="fromDateMenu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      max-width="290px"
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <div>
                          <v-text-field
                            class="mb-6"
                            label="Fecha Nacimiento"
                            readonly
                            persistent-hint
                            hide-details
                            rounded
                            outlined
                            max-width="500"
                            :value="computedDateFormattedDatefns"
                            v-on="on"
                          ></v-text-field>
                        </div>
                      </template>
                      <v-date-picker
                        v-model="formData.birthdate"
                        no-title
                        @input="fromDateMenu = false"
                        :max="maxDate"
                        required
                      ></v-date-picker>
                    </v-menu>
                    <span
                      class="subheading pb-2 secondary--text font-weight-bold"
                      >Género</span
                    >
                    <v-chip-group
                      v-model="formData.gender"
                      column
                      label="Genero"
                      active-class="font-weight-bold"
                    >
                      <v-chip
                        color="secondary"
                        :outlined="formData.gender !== name"
                        large
                        v-for="(name, index) of itemGender"
                        :value="name"
                        :key="index"
                        >{{ name }}</v-chip
                      >
                    </v-chip-group>

                    <p class="subheading pt-6 secondary--text font-weight-bold">
                      Acerca de mi:
                    </p>
                    <v-textarea
                      v-model="formData.aboutMe"
                      autoGrow
                      clearable
                      rounded
                      outlined
                      placeholder="Soy buzo aficionado a explorar nuevos mundos..."
                    ></v-textarea>

                    <div class="d-flex">
                      <v-spacer></v-spacer>
                      <v-btn
                        class="mt-4"
                        color="#009c5e"
                        dark
                        rounded
                        large
                        v-on:click="updateProfile"
                        >Guardar cambios</v-btn
                      >
                    </div>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel class="mt-4 rounded-custom">
              <v-expansion-panel-header class="primary pt-0 pb-0">
                <v-list-item class="pl-0">
                  <v-list-item-avatar>
                    <SvgIcon
                      icon="cp-map-marker"
                      fill="#c0e2e6"
                      height="35px"
                    ></SvgIcon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title
                      class="font-weight-medium title white--text"
                      >Ubicación</v-list-item-title
                    >
                    <v-list-item-subtitle class="white--text"
                      >País, Región, Comuna</v-list-item-subtitle
                    >
                  </v-list-item-content>
                </v-list-item>
              </v-expansion-panel-header>
              <v-expansion-panel-content class="pa-md-4 card-custom-background">
                <v-row class="pt-8">
                  <v-col cols="12" md="10">
                    <v-select
                      label="País"
                      :items="countries"
                      rounded
                      outlined
                      v-model="formData.country"
                    ></v-select>
                    <v-select
                      v-if="formData.country === 'Chile'"
                      label="Región"
                      :items="regions"
                      outlined
                      rounded
                      v-model="formData.region"
                      @input="allProvince(formData.region)"
                    ></v-select>
                    <v-select
                      v-else
                      label="Región"
                      rounded
                      v-model="formData.region"
                      disabled
                    ></v-select>
                    <v-select
                      v-if="formData.country === 'Chile'"
                      label="Comuna"
                      outlined
                      rounded
                      :items="provinces"
                      v-model="formData.province"
                    ></v-select>
                    <v-select
                      v-else
                      label="Comuna"
                      rounded
                      v-model="formData.province"
                      disabled
                    ></v-select>

                    <div class="d-flex">
                      <v-spacer></v-spacer>
                      <v-btn
                        class="mt-4"
                        color="#009c5e"
                        dark
                        rounded
                        large
                        v-on:click="updateProfile"
                        >Guardar cambios</v-btn
                      >
                    </div>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel class="mt-4 rounded-custom">
              <v-expansion-panel-header class="primary pt-0 pb-0">
                <v-list-item class="pl-0">
                  <v-list-item-avatar>
                    <SvgIcon
                      icon="cp-diver-1"
                      fill="#c0e2e6"
                      height="35px"
                    ></SvgIcon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title
                      class="font-weight-medium title white--text"
                      >Buceos</v-list-item-title
                    >
                    <v-list-item-subtitle class="white--text"
                      >Certificaciones, años de buceo</v-list-item-subtitle
                    >
                  </v-list-item-content>
                </v-list-item>
              </v-expansion-panel-header>
              <v-expansion-panel-content class="card-custom-background">
                <v-row class="pt-6">
                  <v-col cols="12">
                    <div>
                      <span class="subheading secondary--text font-weight-bold"
                        >Especialización Ciencias del Mar:</span
                      >

                      <v-chip-group
                        v-model="formData.isSpecialized"
                        column
                        mandatory
                        active-class="font-weight-bold"
                      >
                        <v-chip
                          color="secondary"
                          :outlined="formData.isSpecialized === false"
                          large
                          :value="true"
                          class="pl-10 pr-10"
                          >Si</v-chip
                        >
                        <v-chip
                          color="secondary"
                          :outlined="formData.isSpecialized === true"
                          large
                          :value="false"
                          class="pl-10 pr-10"
                          >No</v-chip
                        >
                      </v-chip-group>
                    </div>
                    <div v-show="formData.isSpecialized" class="mb-2">
                      <span
                        class="subheading secondary--text font-weight-medium"
                        >Especialización:</span
                      >
                      <v-chip-group
                        v-model="formData.seaScienceSpecialized"
                        column
                        multiple
                        active-class="font-weight-bold"
                      >
                        <v-chip
                          color="secondary"
                          :outlined="
                            !(formData.seaScienceSpecialized || []).includes(
                              name
                            )
                          "
                          large
                          v-for="(name, index) of ticksSeaScience"
                          :value="name"
                          :key="index"
                          >{{ name }}</v-chip
                        >
                      </v-chip-group>
                    </div>
                    <div>
                      <v-text-field
                        class="mt-6"
                        v-model="formData.ageDives"
                        label="Años buceando"
                        type="number"
                        rounded
                        outlined
                      ></v-text-field>

                      <span class="subheading secondary--text font-weight-bold"
                        >Horas de buceo acumuladas:</span
                      >
                      <v-chip-group
                        v-model="formData.hrsDives"
                        column
                        active-class="font-weight-bold"
                      >
                        <v-chip
                          color="secondary"
                          :outlined="!(formData.hrsDives == index)"
                          large
                          v-for="(name, index) of ticksLabels"
                          :value="index"
                          :key="index"
                          >{{ name }}</v-chip
                        >
                      </v-chip-group>
                    </div>
                    <v-text-field
                      class="mt-6"
                      v-model="formData.diveCenter"
                      label="Club o Centro Buceo"
                      rounded
                      outlined
                      placeholder="Ej. Bahía Mako"
                    ></v-text-field>
                    <v-textarea
                      v-model="formData.certifications"
                      autoGrow
                      clearable
                      outlined
                      rounded
                      label="Certificaciones"
                      hint="Cuentanos tus certificaciones."
                      placeholder="Ej. PADI"
                    ></v-textarea>

                    <div class="d-flex">
                      <v-spacer></v-spacer>
                      <v-btn
                        class="mt-4"
                        color="#009c5e"
                        dark
                        rounded
                        large
                        v-on:click="updateProfile"
                        >Guardar cambios</v-btn
                      >
                    </div>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>

          <!--             <v-expansion-panels class="mt-4">
              <v-expansion-panel class="rounded-custom">
                <v-expansion-panel-header class="primary pt-0 pb-0">
                  <v-list-item class="pl-0">
                                        <v-list-item-avatar>
                      <SvgIcon icon="cp-diver-1" fill="#c0e2e6" height="35px"></SvgIcon>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title
                        class="font-weight-medium title white--text"
                      >Personalizar apariencia</v-list-item-title>
                      <v-list-item-subtitle class="white--text">Modo oscuro</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="card-custom-background pt-6">
                  <ThemeSelector></ThemeSelector>
                </v-expansion-panel-content>
              </v-expansion-panel>
          </v-expansion-panels>-->
          <!-- <v-subheader class="title">Zona de seguridad</v-subheader> -->
          <PractitionerRestoreAccount></PractitionerRestoreAccount>
        </div>
      </v-col>
    </v-row>
    <v-snackbar
      v-model="snackbarUpdUser"
      color="success"
      :timeout="timeoutSnackbar"
      >Se actualizó tu perfil.</v-snackbar
    >
    <v-snackbar
      v-model="snackbarErrorUpdUser"
      color="error"
      :timeout="timeoutSnackbar"
      >Error al actualizar tu perfil.</v-snackbar
    >
    <v-img
      :src="rollizo"
      height="200"
      width="320"
      contain
      style="position: absolute; bottom: 300px; right: -50px; filter: opacity(20%)"
    ></v-img>
    <v-img
      :src="pinta_roja"
      height="200"
      width="320"
      contain
      style="position: absolute; top: 150px; left: -50px; filter: opacity(20%); transform: scaleX(-1);"
    ></v-img>
    <v-img :src="bilagay" height="200" full-width position="0 40%"></v-img>
  </div>
</template>

<script>
import api from "../../api.js";
import { format, parseISO, formatISO, startOfDay, addMinutes } from "date-fns";
import ThemeSelector from "@/components/ThemeSelector";
import PractitionerAvatar from "@/components/Practitioner/PractitionerAvatar";
import PractitionerProfilePictureUpload from "@/components/Practitioner/PractitionerProfilePictureUpload";
import PractitionerRestoreAccount from "@/components/Practitioner/PractitionerRestoreAccount";
import SvgIcon from "@/components/SvgIcon";
import { mapActions } from "vuex";

export default {
  components: {
    ThemeSelector,
    PractitionerAvatar,
    PractitionerProfilePictureUpload,
    PractitionerRestoreAccount,
    SvgIcon
  },
  data: () => ({
    bilagay: require("@/assets/bilagay.jpg"),
    rollizo: require("@/assets/rollizo.png"),
    pinta_roja: require("@/assets/pinta_roja.png"),
    practitioner: {},
    formData: {
      birthdate: formatISO(new Date(), { representation: "date" })
    },
    practitionerPasswordForm: {},
    showPassword: false,
    showConfirmPassword: false,
    showCurrentPassword: false,
    password: "",
    organismSee: 0,
    userDives: 0,
    ticksSeaScience: ["Biologia Marina", "Acuicultura", "Pescador Artesanal"],
    timeoutSnackbar: 2000,
    show1: false,
    fromDateMenu: false,
    minDate: "1900-01-01",
    maxDate: formatISO(new Date(), { representation: "date" }),
    snackbarUpdUser: false,
    snackbarErrorUpdUser: false,
    url: "",
    countries: [],
    regions: [],
    provinces: [],
    itemGender: ["Femenino", "Masculino", "Prefiero no indicarlo"],
    ticksLabels: [
      "Menor a 10",
      "11 a 30",
      "31 a 60",
      "60 a 100",
      "101 a 300",
      "Mayor a 300"
    ]
  }),
  watch: {
    practitionerLogged() {
      return this.$store.getters["authPractitioner/getPractitioner"];
    }
  },
  methods: {
    ...mapActions("authPractitioner", ["setPractitioner"]),
    async getData() {
      try {
        let { data: practitioner } = await this.$http.get(
          "practitioner/" + this.practitionerLogged.id
        );
        this.formData = {
          ...practitioner,
          birthdate: formatISO(new Date(practitioner.birthdate), {
            representation: "date"
          })
        };
      } catch (err) {
        console.log(err);
      }
    },
    async updateProfile() {
      try {
        let birthdate;
        if (this.formData.birthdate) {
          birthdate = new Date(this.formData.birthdate).getTime();
        }
        let {
          aboutMe,
          ageDives,
          certifications,
          name,
          description,
          diveCenter,
          email,
          gender,
          isSpecialized,
          seaScienceSpecialized,
          hrsDives,
          phone,
          country,
          province,
          region
        } = this.formData;

        let { data: profileUpd } = await this.$http.patch(
          "practitioner/" + this.formData.id,
          {
            aboutMe,
            ageDives,
            birthdate,
            certifications,
            name,
            description,
            diveCenter,
            email,
            gender,
            isSpecialized,
            seaScienceSpecialized,
            hrsDives,
            phone,
            country,
            province,
            region
          }
        );
        this.snackbarUpdUser = true;
        this.setPractitioner(profileUpd);
      } catch (err) {
        this.snackbarErrorUpdUser = true;
        console.log(err);
      }
    },
    async allCountries() {
      await this.axios
        .get("https://restcountries.eu/rest/v2/all?fields=name")
        .then(response => {
          for (let i = 0; i < response.data.length; i++) {
            this.countries.push(response.data[i].name);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    async allRegions() {
      await this.axios
        .get(
          "https://gist.githubusercontent.com/rhernandog/7d055482f5cc803852a762de873bea62/raw/67b8796b6d27cf316e563f9725a087c32f732f0d/regiones-provincias-comunas.json"
        )
        .then(response => {
          for (let i = 0; i < response.data.length; i++) {
            this.regions.push(response.data[i].region);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    async allProvince(r) {
      this.provinces = [];
      await this.axios
        .get(
          "https://gist.githubusercontent.com/rhernandog/7d055482f5cc803852a762de873bea62/raw/67b8796b6d27cf316e563f9725a087c32f732f0d/regiones-provincias-comunas.json"
        )
        .then(response => {
          for (let i = 0; i < response.data.length; i++) {
            if (response.data[i].region === r) {
              for (let z = 0; z < response.data[i].provincias.length; z++) {
                var provi = response.data[i].provincias[z].comunas;
                for (let j = 0; j < provi.length; j++) {
                  this.provinces.push(provi[j].name);
                }
              }
            }
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    async getOrganismCount() {
      try {
        let { data: quantity } = await this.$http.get(
          "practitioner/quantity-organisms?id=" + this.practitionerLogged.id
        );
        this.organismSee = quantity[0].countOrganism;
        this.userDives = quantity[0].dives;
      } catch (err) {
        console.log(err);
      }
    }
  },
  computed: {
    imageHeight() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "40px";
        default:
          return "140px";
      }
    },
    practitionerLogged() {
      return this.$store.getters["authPractitioner/getPractitioner"];
    },
    computedDateFormattedDatefns() {
      return this.formData.birthdate
        ? format(addMinutes(new Date(this.formData.birthdate), 0), "dd/MM/yyyy")
        : "";
    }
  },
  async mounted() {
    this.getOrganismCount();
    this.allCountries();
    this.allRegions();

    await this.getData();
    this.allProvince(this.formData.region);
  }
};
</script>

<style scoped>
.avatar-custom {
  border: 1px solid #0596de;
}

.v-expansion-panel-header {
  border-radius: 20px;
  transition: border-radius 0.5s;
}

.v-expansion-panel-header--active {
  border-radius: 20px 20px 0 0;
}

.v-expansion-panel-content {
  border-radius: 0 0 20px 20px;
}
</style>
